import React from 'react';
import SlimLineCard from '../../../components/containers/cards/SlimLineCard';
import styled from 'styled-components/macro';
import Image from '../../../components/Image';

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 740px;
`;

const Title = styled.h2`
  margin: 0;
  display: flex;
`;

const SubTitle = styled.small``;

const ActionsContainer = styled.div`
  display: flex;
  margin: 0 0 0 auto;
`;

const Icon = styled(Image)`
  width: 3rem;
  margin-right: 2rem;
`;

const IntegrationsCardView = props => {
  return (
    <SlimLineCard $rounded $css="margin-bottom: 1rem">
      <Icon src={props.iconUrl} />
      <InfoContainer>
        <Title>{props.title}</Title>
        <SubTitle>{props.subTitle}</SubTitle>
      </InfoContainer>
      <ActionsContainer>{props.actions}</ActionsContainer>
    </SlimLineCard>
  );
};

export default IntegrationsCardView;
